<template>
  <v-select
      label="title"
      :options="options"
      class="select-standard"
      :class="{'item-danger': warning}"
      :searchable="searchable"
      :placeholder="placeholder"
      v-if="options"
      @option:selected="handleSelect"
  >
  </v-select>
  <GMapAutocomplete
      v-if="!options && autocomplete"
      :placeholder="placeholder"
      @place_changed="setPlace"
      :class="{
          'item-danger': warning,
          'active': isActive && !warning
      }"
      @focus="changeInputStatus"
      @blur="changeInputStatus"
      class="input autocomplete-input"
      :options="autocompleteOptions"
      :value="modelValue"
      ref="autocomplete"
  >
  </GMapAutocomplete>
</template>

<script>
import {watch} from "vue";

export default {
  props: {
    warning: Boolean,
    options: Array,
    selectedOption: String,
    placeholder: String,
    searchable: Boolean,
    autocomplete: Boolean,
    autocompleteOptions: {
      componentRestrictions: {'country': Array},
      fields: Array,
      types: Array
    },
    id: String,
    modelValue: String
  },
  emits: ['placeChanged', 'update:modelValue'],
  methods: {
    handleSelect(e){
      this.$emit('update:modelValue', e)
    },
    changeInputStatus() {
      this.isActive = !this.isActive;
    },
    setPlace(place){
      this.$emit('update:modelValue', place)
      this.$emit('placeChanged', place)
    }
  },
  data(){
    return {
      isActive: false
    }
  }
}
</script>
